document.addEventListener("DOMContentLoaded", function () {
  class ContinuosScroll extends HTMLElement {
    constructor() {
      super();
      this.itemsContainer = this.querySelectorAll('.scroll-items-container');
      this.init();
    }

    init() {
      this.addEventListener('touchstart', this.togglePlayAndPause, { passive: true });
      this.addEventListener('touchend', this.togglePlayAndPause, { passive: true });
    }

    togglePlayAndPause(event) {
      this.itemsContainer.forEach((container) => {
        container.style.animationPlayState = event.type === 'touchstart' ? 'paused' : 'running';
      });
    }
  }

  customElements.define('continuos-scroll', ContinuosScroll);
});